"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollBar = void 0;
var react_1 = require("react");
/**
 * @summary The hook sets the initial state values of scrollX and scrollIsAtEnd,
 *          and uses an effect to check whether the width of the scrollable element is less than or equal to its parent element's width.
 *          If so, it sets scrollIsAtEnd to true.
 * @returns scrollContainerRef: useRef object that can be attached to the container element to enable scrolling
 *          scrollX: state variable that keeps track of the current horizontal scroll position of container
 *          slide (string): function that takes a string argument "left" or "right", and adjusts the scroll position of the container accordingly
 *          scrollIsAtEnd: state (boolean) variable that indicates whether the scroll position of the container is at the end of the scrollable content
 *          scrollIsAtStart: state variable that indicates whether the scroll position of the container is at the start of the scrollable content
 */
var useScrollBar = function () {
    var _a = (0, react_1.useState)(0), scrollX = _a[0], setScrollX = _a[1];
    var _b = (0, react_1.useState)(false), scrollIsAtEnd = _b[0], setScrollIsAtEnd = _b[1];
    var scrollContainerRef = (0, react_1.useRef)(null);
    var slide = function (direction) {
        var _a = scrollContainerRef.current, scrollWidth = _a.scrollWidth, offsetWidth = _a.offsetWidth;
        if (direction === "left") {
            var newScrollX = scrollX + Math.min(offsetWidth, Math.abs(scrollX));
            //newScrollX = minimum value between offsetWidth (the width of container) and Math.abs(scrollX) (distance scrolled from the left edge of the container)
            setScrollX(newScrollX);
        }
        else if (direction === "right") {
            var newScrollX = scrollX - Math.min(offsetWidth, scrollWidth - offsetWidth + scrollX);
            // calculate minimum value between offsetWidth (the width of the container) and 
            // scrollWidth - offsetWidth + scrollX (distance from left edge of container to right edge of scrollable content hidden from view). 
            // result subtracted from scrollX, which gives the new scroll position then used to set scrollX
            setScrollX(newScrollX);
        }
    };
    (0, react_1.useEffect)(function () {
        // update scrollIsAtEnd state variable everytime the scrollX state variable changes. 
        // checks if current scroll position plus the width of the container is equal to the width of the scrollable content, 
        // which indicates that the scroll position is at the end of the content. If scrollIsAtEnd is true and the scroll position changes, set scrollIsAtEnd to false.
        if (Math.abs(scrollX) + scrollContainerRef.current.offsetWidth === scrollContainerRef.current.scrollWidth) {
            setScrollIsAtEnd(true);
        }
        else if (scrollIsAtEnd === true) {
            setScrollIsAtEnd(false);
        }
    }, [scrollX]);
    return {
        scrollContainerRef: scrollContainerRef,
        scrollX: scrollX,
        slide: slide,
        scrollIsAtEnd: scrollIsAtEnd,
        scrollIsAtStart: scrollX === 0
    };
};
exports.useScrollBar = useScrollBar;
